import type { ColumnDef, DefaultSortState } from '@/shared/types/table-filters.types';
import type { JobPositionCandidateWithDetails } from '../types/jobPositionCandidate.types';
import {
  ALL_APPLICATION_STATUSES,
  APPLICATION_STATUS_CONFIG,
} from '../types/jobPositionCandidate.types';

/**
 * The backend serves linked candidates newest applicant first
 * (ORDER BY jpc.applied_at DESC), so that stays the default order rather than
 * the generic "most recently updated first".
 */
export const JOB_POSITION_CANDIDATE_DEFAULT_SORT: DefaultSortState = {
  key: 'appliedAt',
  dir: 'desc',
};

// Reuses the badge labels so the filter and the table never drift apart.
const APPLICATION_STATUS_LABELS: Record<string, string> = Object.fromEntries(
  ALL_APPLICATION_STATUSES.map((status) => [status, APPLICATION_STATUS_CONFIG[status].label])
);

/** Filterable/sortable fields of a candidate linked to a job position. */
export const jobPositionCandidateTableColumns: ColumnDef<JobPositionCandidateWithDetails>[] = [
  {
    key: 'candidateName',
    label: 'Candidate',
    filterType: 'text',
    accessor: (link) => link.candidate.name,
    sortable: true,
  },
  {
    key: 'candidateEmail',
    label: 'Email',
    filterType: 'text',
    accessor: (link) => link.candidate.email,
    sortable: true,
  },
  {
    key: 'candidateCountry',
    label: 'Country',
    filterType: 'text',
    accessor: (link) => link.candidate.country,
    sortable: true,
  },
  {
    key: 'applicationStatus',
    label: 'Status',
    filterType: 'select',
    accessor: (link) => link.applicationStatus,
    options: ALL_APPLICATION_STATUSES,
    optionLabels: APPLICATION_STATUS_LABELS,
    sortable: true,
  },
  {
    key: 'appliedAt',
    label: 'Applied',
    filterType: 'date-range',
    accessor: (link) => link.appliedAt,
    sortable: true,
  },
  {
    key: 'notes',
    label: 'Notes',
    filterType: 'text',
    accessor: (link) => link.notes,
    sortable: true,
  },
];
